export enum EQuizStatsDateInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year'
}

export enum EQuizStatsDateFilterValue {
  DAY = 7,
  WEEK = 30,
  MONTH = 365
}
